/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import {Unit} from '@ion/core/src/units/units';

export const Marks = {
  [Unit.US] : [{
    value : 0,
    label : '0'
  }, {
    value : 25,
    label : '25'
  }, {
    value : 50,
    label : '50'
  }],
  [Unit.IMPERIAL] : [{
    value : 0,
    label : '0'
  }, {
    value : 25,
    label : '25'
  }, {
    value : 50,
    label : '50'
  }],
  [Unit.METRIC] : [{
    value : 0,
    label : '0'
  }, {
    value : 50,
    label : '50'
  }, {
    value : 100,
    label : '100'
  }]
};
